import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  { title: 'Volumetric Flow Rate', description: 'CFM from velocity and duct area', screen: 'AirflowVolumetricFlowRate' },
  { title: 'Velocity of Air', description: 'Velocity from CFM and duct area', screen: 'AirflowVelocityOfAir' },
  { title: 'Duct Area', description: 'Area from rectangular or round duct dimensions', screen: 'AirflowDuctArea' },
  { title: 'Duct Size from CFM', description: 'Required duct size for a target CFM', screen: 'AirflowDuctSizeFromCFM' },
  { title: 'Equivalent Round Duct', description: 'Equivalent round diameter from rectangular dimensions', screen: 'AirflowEquivalentRoundDuct' },
  { title: 'Air Changes', description: 'Air changes per hour from CFM and room volume', screen: 'AirflowAirChanges' },
  { title: 'Hood Face Velocity', description: 'Face velocity across a hood opening', screen: 'AirflowHoodFaceVelocity' },
  { title: 'Flow Hood K-Factor', description: 'Corrected CFM using a flow hood K-factor', screen: 'AirflowFlowHoodKFactor' },
  { title: 'Pitot Traverse Averaging', description: 'Average velocity pressure from a pitot traverse', screen: 'AirflowPitotTraverseAveraging' },
  { title: 'Pitot Traverse Grid', description: 'Log-Tchebycheff / equal-area grid for traverses', screen: 'AirflowPitotTraverseGrid' },
  { title: 'Duct Traverse Points', description: 'Traverse point layout for round, rectangular, and flat oval ducts', screen: 'DuctTraverse' },
  { title: 'Total Pressure', description: 'Total, static, and velocity pressure relationships', screen: 'AirflowTotalPressure' },
  { title: 'Duct Leakage (Class)', description: 'Duct leakage class evaluation', screen: 'AirflowDuctLeakageClass' },
];

export default function TABAirflowScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Airflow Calculations" subtitle="TAB · Airflow & velocity">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c) => (
        <CategoryCard
          key={c.screen}
          title={c.title}
          description={c.description}
          cta="Open →"
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
